import { IndexPage } from './IndexPage';

export {
IndexPage
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/ErrorLog/index.ts
 **/